var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner-box-container"},[_c('div',{staticClass:"spinner-box"},[_c('pixel-spinner',{attrs:{"animation-duration":2000,"color":_vm.colorData,"size":120}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }